import workspaceQuery from '../../../graphql/queries/sales/EbayConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/EbayConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/EbayConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/EbayConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/EbayConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/EbayConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const EbayConfiguration: EntityType = {
  type: 'EbayConfiguration',
  title: 'eBay Configurations',
  formTitle: 'ebay Configuration',
  formUrl: '/Sales/Channel/EbayConfig/Details/',
  workspaceUrl: '/Sales/Channel/EbayConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_EBAY_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default EbayConfiguration;
